"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMultipartUploadOutput = {
    type: "structure",
    required: [],
    members: {
        AbortDate: {
            shape: {
                type: "timestamp"
            },
            location: "header",
            locationName: "x-amz-abort-date"
        },
        AbortRuleId: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-abort-rule-id"
        },
        Bucket: {
            shape: {
                type: "string"
            },
            locationName: "Bucket"
        },
        Key: {
            shape: {
                type: "string",
                min: 1
            }
        },
        UploadId: {
            shape: {
                type: "string"
            }
        },
        ServerSideEncryption: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-server-side-encryption"
        },
        SSECustomerAlgorithm: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-customer-algorithm"
        },
        SSECustomerKeyMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-customer-key-MD5"
        },
        SSEKMSKeyId: {
            shape: {
                type: "string",
                sensitive: true
            },
            location: "header",
            locationName: "x-amz-server-side-encryption-aws-kms-key-id"
        },
        RequestCharged: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-charged"
        }
    }
};
//# sourceMappingURL=CreateMultipartUploadOutput.js.map